import React from 'react'
import { useForm } from 'react-hook-form'

import OrangeButton from '../../../../components/Buttons/OrangeButton'
import Notification from './Notification'

import { notificationsSettings } from '../../../../constants'

const EmailNotifications = () => {
  const { handleSubmit, control } = useForm()

  const handleFormSubmit = (data) => {
    console.log(data)
  }

  const notificationsSettingsContent = notificationsSettings.map((notificationsSetting) => {
    return (
      <Notification
        key={notificationsSetting.title}
        notificationsSetting={notificationsSetting}
        control={control}
      />
    )
  })

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <div className="w-full border-[1px] border-[#FFCA84] rounded-lg p-[20px]">
        <div className="w-full flex flex-col items-start gap-y-[32px]">
          {notificationsSettingsContent}
        </div>
      </div>

      <OrangeButton type="submit" text="Save Changes" className="mt-[20px]" />
    </form>
  )
}

export default EmailNotifications
